import BaseModel from './BaseModel';
import { createDataExtractionField } from './DataExtractionField';

export default class DataExtractionFieldDraft extends BaseModel {
  constructor(data = {}) {
    super(DataExtractionFieldDraft, data);
    this.id = data.id;
    this.modified = data.modified;
    this.existingField = data.existingField
      ? createDataExtractionField(data.existingField)
      : null;
    this.updatedField = data.updatedField
      ? createDataExtractionField(data.updatedField)
      : null;
  }

  toInput() {
    return {
      id: this.id,
      modified: this.modified,
      existingField: this.existingField?.id,
      updatedField: this.updatedField?.id,
    };
  }
}
